import React, {Component} from "react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import axios from "axios/index";
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";

class DropDownTvGenres extends Component {

    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);
        this.state = {
            loading: true,
            gGenresArray: []
        };

    }

    handleSelect(value) {
        this.props.handlerFromParent(value);
    }

    componentDidMount() {

        const url = process.env.REACT_APP_API_URL+"/Global/TvGenres";

        let user = JSON.parse(localStorage.getItem('user'));

        let token = ""

        if(user){
            token = user.token
        }
        else{
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {'X-Id-Token': token}
        };

        axios
            .get(url,axiosConfig)
            .then(res => {
                const gGenresArray = res.data;
                const loading = false;
                this.setState({gGenresArray, loading});
            })
            .catch(error => {
                this.setState({loading: false});
                console.log(error);
                this.props.dispatch(userActions.logoutUnauthorized());
            });
    }

    render() {
        return (
            <Select
                placeholder="Genre Select"
                name="genreSelect"
                autoFocus={false}
                multi={true}
                isSearchable={true}
                disabled={this.props.disabled}
                value={this.props.genreSelected}
                options={this.state.gGenresArray}
                onChange={value => this.handleSelect(value)}

            />
        );
    }

}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedDropDownTvGenres = connect(mapStateToProps)(DropDownTvGenres);
const connectedDropDownTvGenresTrans = withNamespaces('common')(connectedDropDownTvGenres);
export {connectedDropDownTvGenresTrans as DropDownTvGenres};

